<div class="beneficiary-container">
  <p appConfigSettingsParagraph>
    {{ 'Beneficiaries.Information' | translate }}
  </p>

  <p appConfigSettingsParagraph>
    {{ 'Beneficiaries.StandardBeneficiaryListTitle' | translate }}</p>
  <ol appConfigSettingsParagraph>
    <li>{{ 'BeneficiaryTypeEnum.POLICY_HOLDER' | translate }}</li>
    <li>{{ 'BeneficiaryTypeEnum.WIDOW' | translate }}</li>
    <li>{{ 'BeneficiaryTypeEnum.CHILDREN' | translate }}</li>
    <li>{{ 'BeneficiaryTypeEnum.HEIRS' | translate }}</li>
  </ol>

  <div class="mb-20">
    <app-toggle-input
      class="full-width"
      placeholder="Beneficiaries.DefaultOrCustom"
      [form]="beneficiariesFormGroup"
      [optionsList]="beneficiaryOrder"
      [control]="beneficiariesFormGroup.get('beneficiaryOrder')"
    ></app-toggle-input>
  </div>
  <div *ngIf="beneficiariesFormGroup.get('beneficiaryOrder').value === 'CUSTOM'">
    <div>
      <div>
        <app-select-box
          class="full-width"
          appConfigSettingsInput
          placeholder="Beneficiaries.Beneficiary1"
          [form]="beneficiariesFormGroup"
          [optionsList]="beneficiaryUsageOrderList"
          [control]="beneficiariesFormGroup.get('beneficiary1').get('usageOrder')"
          [isDisabled]="beneficiariesFormGroup.value.beneficiaryOrder == BeneficiaryOrderEnum.DEFAULT"
          [textColor]="configSettings.inputColor"
          [inputColor]="configSettings.inputColor"
          [fontFamily]="FontTypeEnum[configSettings.fontType]"
          [backgroundHoverColor]="configSettings.backgroundColor"
          [backgroundHoverTextColor]="configSettings.backgroundTextColor"
        ></app-select-box>
      </div>
      <div>
        <div class="customBeneficiary"
             appConfigSettingsInput
             *ngIf="beneficiariesFormGroup.get('beneficiary1').get('usageOrder').value == BeneficiaryTypeEnum.OTHER"
        >
          <app-application-custom-beneficiary
            [customBeneficiaryFormGroup]="beneficiariesFormGroup.get('beneficiary1')"
          ></app-application-custom-beneficiary>
        </div>
      </div>
    </div>
    <div>
      <div>
        <app-select-box
          class="full-width"
          appConfigSettingsInput
          placeholder="Beneficiaries.Beneficiary2"
          [form]="beneficiariesFormGroup"
          [optionsList]="beneficiaryUsageOrderList"
          [control]="beneficiariesFormGroup.get('beneficiary2').get('usageOrder')"
          [isDisabled]="beneficiariesFormGroup.value.beneficiaryOrder == BeneficiaryOrderEnum.DEFAULT"
          [textColor]="configSettings.inputColor"
          [inputColor]="configSettings.inputColor"
          [fontFamily]="FontTypeEnum[configSettings.fontType]"
          [backgroundHoverColor]="configSettings.backgroundColor"
          [backgroundHoverTextColor]="configSettings.backgroundTextColor"
        ></app-select-box>
      </div>
      <div>
        <div class="customBeneficiary"
             appConfigSettingsInput
             *ngIf="beneficiariesFormGroup.get('beneficiary2').get('usageOrder').value == BeneficiaryTypeEnum.OTHER"
        >
          <app-application-custom-beneficiary
            [customBeneficiaryFormGroup]="beneficiariesFormGroup.get('beneficiary2')"
          ></app-application-custom-beneficiary>
        </div>
      </div>
    </div>
    <div>
      <div>
        <app-select-box
          class="full-width"
          appConfigSettingsInput
          placeholder="Beneficiaries.Beneficiary3"
          [form]="beneficiariesFormGroup"
          [optionsList]="beneficiaryUsageOrderList"
          [control]="beneficiariesFormGroup.get('beneficiary3').get('usageOrder')"
          [isDisabled]="beneficiariesFormGroup.value.beneficiaryOrder == BeneficiaryOrderEnum.DEFAULT"
          [textColor]="configSettings.inputColor"
          [inputColor]="configSettings.inputColor"
          [fontFamily]="FontTypeEnum[configSettings.fontType]"
          [backgroundHoverColor]="configSettings.backgroundColor"
          [backgroundHoverTextColor]="configSettings.backgroundTextColor"
          forceOptionListOverflow="true"
        ></app-select-box>
      </div>
      <div>
        <div class="customBeneficiary"
             appConfigSettingsInput
             *ngIf="beneficiariesFormGroup.get('beneficiary3').get('usageOrder').value == BeneficiaryTypeEnum.OTHER"
        >
          <app-application-custom-beneficiary
            [customBeneficiaryFormGroup]="beneficiariesFormGroup.get('beneficiary3')"
          ></app-application-custom-beneficiary>
        </div>
      </div>
    </div>
    <div>
      <div>
        <app-select-box
          class="full-width"
          appConfigSettingsInput
          placeholder="Beneficiaries.Beneficiary4"
          [form]="beneficiariesFormGroup"
          [optionsList]="beneficiaryUsageOrderList"
          [control]="beneficiariesFormGroup.get('beneficiary4').get('usageOrder')"
          [isDisabled]="beneficiariesFormGroup.value.beneficiaryOrder == BeneficiaryOrderEnum.DEFAULT"
          [textColor]="configSettings.inputColor"
          [inputColor]="configSettings.inputColor"
          [fontFamily]="FontTypeEnum[configSettings.fontType]"
          [backgroundHoverColor]="configSettings.backgroundColor"
          [backgroundHoverTextColor]="configSettings.backgroundTextColor"
          forceOptionListOverflow="true"
        ></app-select-box>
      </div>
      <div>
        <div class="customBeneficiary"
             appConfigSettingsInput
             *ngIf="beneficiariesFormGroup.get('beneficiary4').get('usageOrder').value == BeneficiaryTypeEnum.OTHER"
        >
          <app-application-custom-beneficiary
            [customBeneficiaryFormGroup]="beneficiariesFormGroup.get('beneficiary4')"
          ></app-application-custom-beneficiary>
        </div>
      </div>
    </div>
  </div>
</div>
